<template>
  <div>
    <h3>DEBUG COMPONENT</h3>
    <hr>
    <file-upload-new fileuploadid="control1" :ticketref="s_ticketref"
                     :psgref="s_psgref"
                     filetype="7"
                     @uploadcomplete="uploadCompletato(1)"
                     :label='this.$i18n.t("message.fup_caricafile")'
    ></file-upload-new>
    <br>
    <file-upload-new
        fileuploadid="control2"
        :ticketref="s_ticketref"
        :psgref="s_psgref" filetype="7"
        @uploadcomplete="uploadCompletato($event)"
        :label='this.$i18n.t("message.fup_caricafile")'
        :showimage="true"
    ></file-upload-new>
    <br>
    <file-upload-new
        fileuploadid="control3"
        :key="uploadkey"
        :ticketref="s_ticketref"
        :psgref="s_psgref" filetype="5"
        v-model="filecaricato"
        @uploadcomplete="uploadCompletatoRefresh($event)"
        :label='this.$i18n.t("message.fup_caricafile")'
    ></file-upload-new>
    <hr>
  </div>
</template>

<script>
import FileUploadNew from "@/components/FileUploadNew";
export default {
  name: "DebugComponent",
  components:{
    FileUploadNew,
  },
  data(){
    return{
      s_ticketref:"zj2hNLqNYMY%3D",
      s_psgref:"p8YdeWDHLdk%3D",
      uploadkey : 1,
      filecaricato: null,
    }
  },
  mounted() {
    this.$root.$i18n.locale = this.$route.params.locale;
  },
  methods:{
    uploadCompletato(num){
      console.log(num);
    },
    uploadCompletatoRefresh(num){
      this.uploadkey++;
      console.log(num);
    }
  }
}
</script>

<style scoped>

</style>